import { Component } from 'react';
import { connect } from 'react-redux';

import { MANAGERS, NAVIGATIONS } from 'data/static';
import { Dispatch } from 'redux';
import { Layout, RootState } from 'types';
import { checkDifferent, clone } from 'utils/formHandlers';
import { withRouter } from 'utils/withRouter';

import DrawingMenu from './menus/DrawingMenu';
import FavouritMenu from './menus/FavouritMenu';
import HighlightMenu from './menus/HighlightMenu';
import InspectTransitMenu from './menus/InspectTransitMenu';
import LayersMenu from './menus/LayersMenu';
import PlansMenu from './menus/PlansMenu';
import PlaybackMenu from './menus/PlaybackMenu';
import SearchMenu from './menus/SearchMenu';
import TimeMenu from './menus/TimeMenu';
import System from './system/System';
import SystemConsole from './system/SystemConsole';

// import FormBuilder from './formBuilder';

interface MenuManagerProps {
    layout: Layout;
    navigate: (path: string) => void; // Add navigation prop
}

interface MenuManagerState {
    layout: Layout;
    searchId: string;
    inspectId: string;
    playbackId: string;
}

class MenuManager extends Component<MenuManagerProps, MenuManagerState> {
    constructor(props: MenuManagerProps) {
        super(props);
        this.state = {
            layout: clone(props.layout),
            searchId: '',
            inspectId: '',
            playbackId: '',
        };
    }

    static getDerivedStateFromProps(props: MenuManagerProps, state: MenuManagerState) {
        if (checkDifferent(props.layout, state.layout)) {
            return {
                layout: clone(props.layout),
                inspectId: props.layout.inspectId,
                playbackId: props.layout.playbackId,
                searchId: props.layout.searchId,
            };
        }

        return null;
    }

    componentDidUpdate(prevProps: Readonly<MenuManagerProps>, prevState: Readonly<MenuManagerState>): void {
        if (checkDifferent(this.state.layout, prevState.layout)) {
            const section =
                Object.keys(this.state.layout.sections).find((section) => this.state.layout.sections[section].state) ||
                'chart';

            if (NAVIGATIONS.includes(section) || MANAGERS.includes(section)) {
                if (!this.state.layout.allowNavigation) {
                    return;
                }

                this.props.navigate(`/${section}`);
            }
        }
    }

    render() {
        return (
            <>
                <DrawingMenu
                    active={
                        (this.state.layout.sections.chart.menus.drawingMenu.state &&
                            this.state.layout.sections.chart.state) ||
                        (this.state.layout.sections.time.menus.drawingMenu.state &&
                            this.state.layout.sections.time.state) ||
                        (this.state.layout.sections.playback.menus.drawingMenu.state &&
                            this.state.layout.sections.playback.state)
                    }
                ></DrawingMenu>

                <LayersMenu
                    active={
                        (this.state.layout.sections.chart.menus.layersMenu.state &&
                            this.state.layout.sections.chart.state) ||
                        (this.state.layout.sections.time.menus.layersMenu.state &&
                            this.state.layout.sections.time.state) ||
                        (this.state.layout.sections.playback.menus.layersMenu.state &&
                            this.state.layout.sections.playback.state)
                    }
                ></LayersMenu>

                <PlansMenu
                    active={
                        (this.state.layout.sections.chart.menus.plansMenu.state &&
                            this.state.layout.sections.chart.state) ||
                        (this.state.layout.sections.time.menus.plansMenu.state &&
                            this.state.layout.sections.time.state) ||
                        (this.state.layout.sections.playback.menus.plansMenu.state &&
                            this.state.layout.sections.playback.state) ||
                        (this.state.layout.sections.profile.menus.plansMenu.state &&
                            this.state.layout.sections.profile.state)
                    }
                ></PlansMenu>

                <System active={this.state.layout.sections.system.menus.system.state}></System>
                <SystemConsole active={this.state.layout.sections.system.menus.systemConsole.state}></SystemConsole>

                <PlaybackMenu
                    active={
                        this.state.layout.sections?.playback.menus?.playbackMenu.state &&
                        this.state.layout.sections.playback.state
                    }
                ></PlaybackMenu>

                <TimeMenu
                    active={
                        this.state.layout.sections?.time.menus?.timeMenu.state && this.state.layout.sections.time.state
                    }
                ></TimeMenu>

                <FavouritMenu
                    active={
                        (this.state.layout.sections?.grid.menus?.searchMenu.state &&
                            this.state.layout.sections?.grid.menus?.searchMenu.sections.loadFavourit.state &&
                            this.state.layout.sections.grid.state) ||
                        (this.state.layout.sections?.chart.menus?.searchMenu.state &&
                            this.state.layout.sections?.chart.menus?.searchMenu.sections.loadFavourit.state &&
                            this.state.layout.sections.chart.state) ||
                        (this.state.layout.sections?.profile.menus?.searchMenu.state &&
                            this.state.layout.sections?.profile.menus?.searchMenu.sections.loadFavourit.state &&
                            this.state.layout.sections.profile.state)
                    }
                ></FavouritMenu>

                <SearchMenu
                    active={
                        (this.state.layout.sections?.grid.menus?.searchMenu.state &&
                            this.state.layout.sections.grid.state &&
                            !this.state.layout.sections?.grid.menus?.searchMenu.sections.loadFavourit.state) ||
                        (this.state.layout.sections?.chart.menus?.searchMenu.state &&
                            this.state.layout.sections.chart.state &&
                            !this.state.layout.sections?.chart.menus?.searchMenu.sections.loadFavourit.state) ||
                        (this.state.layout.sections?.profile.menus?.searchMenu.state &&
                            this.state.layout.sections.profile.state &&
                            !this.state.layout.sections?.profile.menus?.searchMenu.sections.loadFavourit.state)
                    }
                ></SearchMenu>

                <InspectTransitMenu
                    active={
                        (this.state.layout.sections?.chart.menus?.inspectTransitMenu.state &&
                            this.state.layout.sections.chart.state) ||
                        (this.state.layout.sections?.grid.menus?.inspectTransitMenu.state &&
                            this.state.layout.sections.grid.state)
                    }
                ></InspectTransitMenu>

                <HighlightMenu
                    active={
                        (this.state.layout.sections?.grid.menus?.highlightMenu.state &&
                            this.state.layout.sections.grid.state) ||
                        (this.state.layout.sections?.chart.menus?.highlightMenu.state &&
                            this.state.layout.sections.chart.state) ||
                        (this.state.layout.sections?.profile.menus?.highlightMenu.state &&
                            this.state.layout.sections.profile.state)
                    }
                ></HighlightMenu>
            </>
        );
    }
}

const mapStateToProps = (state: RootState) => ({
    layout: state.layout.layout,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(MenuManager));
